import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import useWindowSize from 'design_system/src/hooks/useWindowSize';
import Sidebar from 'components/layouts/main/sidebar/Sidebar';
import MobileNav from 'components/layouts/main/mobileNav/MobileNav';

import './layout.scss';

const MOBILE_BREAKPOINT = 768;

function Layout() {
	const location = useLocation();
	const { width } = useWindowSize();
	const isMobile = width < MOBILE_BREAKPOINT;
	const isMapRoute = location.pathname.startsWith('/map');
	const isMapFullScreen = isMobile && isMapRoute;
	const rootClassName = `rootL ${isMapFullScreen ? 'rootL_map_full' : ''} ${
		isMobile ? 'rootL_mobile' : ''
	}`;

	return (
		<div className={rootClassName}>
			<Sidebar />
			<div className="main">
				<div className="container">
					<Outlet />
				</div>
			</div>
			{isMobile && <MobileNav />}
		</div>
	);
}

export default Layout;
